import { Activity } from "../../components/activity/types";
import { useGeneralStore } from "../../stores";
import { Customer } from "../../types";
import Api from "../api";

class CustomerApi extends Api {
  static getAll(): Promise<Array<Customer>> {
    return this.getData("/customer");
  }

  static addCustomer(
    fullname: string,
    national_code: string,
    phone: string,
    address: string,
    tags: Array<string>
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      this.postData<Customer, {}>("/customer", {
        fullname,
        national_code,
        phone,
        address,
        tags,
      })
        .then((customer) => {
          useGeneralStore.getState().addCustomer(customer);
          resolve();
        })
        .catch((err) => reject(err));
    });
  }

  static editCustomer(
    id: string,
    fullname: string,
    national_code: string,
    phone: string,
    address: string,
    tags: Array<string>
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      let data = {} as any;
      if (fullname) data.fullname = fullname;
      if (national_code) data.national_code = national_code;
      if (phone) data.phone = phone;
      if (address) data.address = address;
      if (tags) data.tags = tags;
      this.patchData<Customer, {}>(`/customer/${id}`, data)
        .then((customer) => {
          useGeneralStore.getState().editCustomer(customer);
          resolve();
        })
        .catch((err) => reject(err));
    });
  }

  static deleteCustomer(customer: Customer): Promise<void> {
    return new Promise((resolve, reject) => {
      this.deleteData<Activity>(`/customer/${customer._id.$oid}`)
        .then((res) => {
          useGeneralStore.getState().deleteCustomer(customer._id.$oid, res);
          resolve();
        })
        .catch((err) => reject(err));
    });
  }
}

export default CustomerApi;
